/*
  cart-page-note.js

  Cart page order note. Mirrors assets/cart-drawer-note.js: the note is written
  with /cart/update.js on save rather than riding along with a form submit, and
  the card label switches to "Edit order note" with a pencil once something is
  stored. Delegated listeners throughout, so a section re-render cannot leave
  the card inert.
*/
(function () {
  'use strict';

  function card() {
    return document.querySelector('[data-crn]');
  }

  function q(sel) {
    var c = card();
    return c ? c.querySelector(sel) : null;
  }

  function setOpen(open) {
    var body = q('[data-crn-body]');
    var btn = q('[data-crn-toggle]');
    if (!body || !btn) return;

    body.hidden = !open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');

    if (open) {
      var input = q('[data-crn-input]');
      if (input) {
        setTimeout(function () {
          input.focus();
          input.setSelectionRange(input.value.length, input.value.length);
        }, 50);
      }
    } else {
      showMsg('', null);
    }
  }

  function showMsg(text, kind) {
    var m = q('[data-crn-msg]');
    if (!m) return;
    if (!text) {
      m.hidden = true;
      m.textContent = '';
      return;
    }
    m.textContent = text;
    m.className = 'cr__codemsg crn__msg is--' + (kind || 'note');
    m.hidden = false;
  }

  function reflect(note) {
    var c = card();
    if (!c) return;

    var filled = !!(note && note.trim());
    var label = c.querySelector('[data-crn-label]');
    var icon = c.querySelector('.crn__icon');
    var del = c.querySelector('[data-crn-delete]');

    if (label) {
      label.textContent = filled
        ? c.getAttribute('data-label-filled')
        : c.getAttribute('data-label-empty');
    }
    if (icon) icon.classList.toggle('is--filled', filled);
    if (del) del.hidden = !filled;
  }

  function post(note) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: note })
    }).then(function (r) { return r.json(); });
  }

  function save() {
    var input = q('[data-crn-input]');
    var btn = q('[data-crn-save]');
    if (!input) return;

    if (btn) btn.disabled = true;

    post(input.value)
      .then(function (cart) {
        reflect(cart.note);
        setOpen(false);
      })
      .catch(function () {
        showMsg(card().getAttribute('data-msg-error') || 'Could not save your note. Please try again.', 'err');
      })
      .then(function () {
        if (btn) btn.disabled = false;
      });
  }

  function wipe() {
    var input = q('[data-crn-input]');
    var del = q('[data-crn-delete]');
    if (del) del.disabled = true;

    post('')
      .then(function (cart) {
        if (input) input.value = '';
        reflect(cart.note);
        setOpen(false);
      })
      .catch(function () {
        showMsg(card().getAttribute('data-msg-error') || 'Could not remove your note. Please try again.', 'err');
      })
      .then(function () {
        if (del) del.disabled = false;
      });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    if (e.target.closest('[data-crn-toggle]')) {
      e.preventDefault();
      var body = q('[data-crn-body]');
      setOpen(body ? body.hidden : true);
      return;
    }
    if (e.target.closest('[data-crn-save]')) { e.preventDefault(); save(); return; }
    if (e.target.closest('[data-crn-delete]')) { e.preventDefault(); wipe(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && (e.metaKey || e.ctrlKey) && e.target.matches('[data-crn-input]')) {
      e.preventDefault();
      save();
    }
  });

  /* After a cart re-render the markup is fresh; re-read what Shopify holds. */
  function sync() {
    if (!card()) return;
    fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { reflect(c.note); })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
  document.addEventListener('cart:section-refreshed', sync);
})();
